import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { DigitalVaultDocumentView } from '../../views'
import { LocalStorageService, QuestionnaireService, CategoryService, DigitalVaultService, DigitalVaultDocumentService, DocumentLogsService, CacheStorageService, UserService, AlertService, ClientService, DocumentsType } from '../../../services'
import { changeFormatNumberToShow, decryptMessageBoveda, FormatTextUtil, getNavigatorTimezone, parseEntities, setCreditsToDocuments } from '../../../utils'

class DigitalVaultDocumentAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showWarning: false,
            showCompletedRequesting: false,
            messageComplete: '',
            messageError: '',
            messageWarning: '',
            showPrincipalView: true,
            showEditView: false,
            fromDelete: false,
            id: 0,
            dataLoaded: false,
            documentData: {
                id: 0,
                name: '',
                alias: '',
                description: '',
                nameUser: '',
                infoType: '',
                typeDocument: '',
                startDate: '',
                validationDate: '',
                amount: '',
                tags: '',
                confidential: false,
                obligatory: false,
                penaltyFee: '',
                renewal: '',
                daysTo: 0,
                percent: 0,
                signedInGovo: false
            },
            showBasicInfo: true,
            showCircle: false,
            formatTransaction: '$0.0',
            formatPenaltyFee: '$0.0',
            showActions: true,
            showPDF: true,
            showPanelVaribales: true,
            showPanelBinnacle: true,
            showVersions: false,
            showPanelEntities: true,
            variables: [],
            binnacle: [],
            url: '',
            permissions: [],
            removeTags: false,
            selectedFile: null,
            selectedFileName: '',
            errorFile: false,
            selectedFileBase64: '',
            colorBorderContainer: 'gray',
            fileWasUpload64: '',
            actionOptions: [],
            versions: [],
            showVersionsBtns: true,
            showExpediente: false,
            filesExpediente: [],
            fileExpSelected: {},
            versionSelected: {},
            userCollaborators: [],
            showBtnAddDocumentToExp: false,
            monetaryUnits: [],
            fileType: 'pdf',
            asn1Decode: [],
            typesDocuments: [],
            typeDocumentId: null,
            variablesGrid: [],
            entities: [],
            entitiesStatus: '',
            showDialogExtractEntities: false,
            documentsToOCR: [],
            totalCredits: 0,
            filesDocument: [],
            titleDialog: '',
            formatVariables: [],
            showLeftDownload: false,
            showShareLeft: false,
            showDeleteLeft: false,
            showEditLeft: false,
            showBtnExtractEntities: false,
            preferenceIA: process.env.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ON_DEMAND
        }
    }
    ENV = process.env
    token = {}
    user = {}
    id = 0
    url = this.ENV.REACT_APP_MIFIRMA_API
    localStorageService = new LocalStorageService()
    categoryService = new CategoryService(process.env.REACT_APP_MIFIRMA_API)
    digitalVaultService = new DigitalVaultService(this.url)
    documentLogsService = new DocumentLogsService(process.env.REACT_APP_MIFIRMA_API)
    digitalVaultDocumentService = new DigitalVaultDocumentService(this.url)
    documentTypesService = new DocumentsType(this.url)
    alertService = new AlertService(this.url)
    questionnaireService = new QuestionnaireService(this.url)
    userService = new UserService(this.url)
    cache = new CacheStorageService()
    formatTextUtil = new FormatTextUtil()
    clientPreferencesService = new ClientService(this.url)

    timezone = getNavigatorTimezone()

    loadingDocumentData = false
    loadingBinnacle = false
    loadingUsersCollabs = false
    loadingMonetaryUnits = false
    loadingFormatVariables = false

    /**
     * @typedef {(data: import('../../../types/alerts.types').AlertData) => Promise<boolean>} CreateAlert
     * @param {import('../../../types/alerts.types').AlertData} data
     * @returns {Promise<boolean>}
     */

    async componentDidMount() {
        if (this.state.dataLoaded || this.state.isLoading) {
            return
        }
        this.toggleLoadingView(true)
        this.token = this.localStorageService.getLocalStorageItem('token').idToken
        this.user = this.localStorageService.getLocalStorageItem('user')
        this.id = this.props.documentId

        const searchParams = new URLSearchParams(window.location.search)
        const hash = window.location.hash || ''
        const queryString = hash.includes('?') ? hash.split('?')[1] : ''
        const hashParams = new URLSearchParams(queryString)
        const fromDelete = (typeof this.props.fromDelete === 'boolean')
            ? this.props.fromDelete
            : (hashParams.get('fromDelete') === 'true' || searchParams.get('fromDelete') === 'true')

        this.setState({
            fromDelete: fromDelete,
            id: this.props.documentId,
            dataLoaded: true
        })

        try {
            await Promise.all([
                this.getDocumentData(),
                this.getBinnacle(),
                this.getUsersCollabs(),
                this.getMonetaryUnits(),
                this.getFormatVariables()
            ])
        } catch (error) {
            console.error('Error loading initial data:', error)
        }
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.documentId !== this.props.documentId) {
            this.setState({ dataLoaded: false }, () => {
                this.componentDidMount()
            })
        }
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoading: value
        })
    }

    toggleWarning = (message, time, title) => {
        this.setState({
            showWarning: true,
            messageWarning: message,
            titleDialog: title
        }, () => {
            setTimeout(() => {
                this.setState({
                    showWarning: false,
                })
            }, time || 0)
        })
    }

    toggleErrorRequesting = (message, time, sendInbox, path, title) => {
        let sendTo = (path && path !== '') ? path : '/'
        this.setState({
            showErrorRequesting: true,
            messageError: message,
            titleDialog: title
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time)
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        })
    }

    toggleCompletedRequesting = (time, sendInbox, path, title, message) => {
        let sendTo = (path && path !== '') ? path : '/'
        this.setState({
            showCompletedRequesting: true,
            messageComplete: message,
            titleDialog: title
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time)
        })
    }

    getDocumentData = async () => {
        if (this.loadingDocumentData) {
            console.warn('getDocumentData already in progress, skipping duplicate call')
            return
        }
        this.loadingDocumentData = true
        let messageError = 'Ocurrió un error al consultar la infomación del documento'
        try {
            let documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
            if (documentInfo && documentInfo.data && Number(documentInfo.statusCode) === 200) {
                let showCircle = (documentInfo.data.document && documentInfo.data.document.obligatory) ? documentInfo.data.document.obligatory : false
                let formatTransaction = (documentInfo.data.document && documentInfo.data.document.amount && documentInfo.data.document.amount > 0) ? `$${changeFormatNumberToShow(documentInfo.data.document.amount, 1)}` : '$0.0'
                let formatPenaltyFee = (documentInfo.data.document && documentInfo.data.document.penaltyFee === true) ? true : false
                let decryptUrl = ''
                let versions = []
                let versionSelected = {}
                let fileType = 'pdf'

                let signedInGovo = documentInfo.data.signedInGovo


                let asn1Decode = []
                const isAsn1OctetFile = (expediente, ENV) => {
                    return (
                        expediente.fileType === ENV.REACT_APP_OCTET_STREAM_TYPE &&
                        expediente.extension === ENV.REACT_APP_ASN1_EXTENSION
                    )
                }

                if (documentInfo.data.expediente?.length) {
                    documentInfo.data.expediente.map((expediente) => {
                        expediente.asn1Parse = {}

                        if (isAsn1OctetFile(expediente, this.ENV)) {
                            expediente.asn1Parse = {
                                localityName: expediente.detail?.localityName,
                                stateOrProvinceName: expediente.detail?.stateOrProvinceName,
                                countryName: expediente.detail?.countryName,
                                postalCode: expediente.detail?.postalCode,
                                streetAddress: expediente.detail?.streetAddress,
                                commonName: expediente.detail?.commonName,
                                organizationalUnitName: expediente.detail?.organizationalUnitName,
                                organizationName: expediente.detail?.organizationName,
                                emailAddress: expediente.detail?.emailAddress,
                                cRLDistributionPoints: expediente.detail?.cRLDistributionPoints,
                                certificatePolicies: expediente.detail?.certificatePolicies,
                                pscTimeValidated: expediente.detail?.pscTimeValidated,
                                signingTime: expediente.detail?.signingTime,
                            }
                        }

                        return expediente
                    })

                    const asn1FileOne = documentInfo.data.expediente.find((expediente) =>
                        isAsn1OctetFile(expediente, this.ENV)
                    )

                    asn1Decode = asn1FileOne?.asn1Parse ? [asn1FileOne.asn1Parse] : []
                }

                let filesDocument = []
                if (documentInfo.data.document.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
                    let file = (documentInfo.data.expediente?.length) ? documentInfo.data.expediente[0] : null
                    decryptUrl = (file && file.url && file.url !== '') ? decryptMessageBoveda(file.url) : ''
                    fileType = file && file.fileType

                    let versionsFile = (documentInfo.data.expediente?.length > 0 && documentInfo.data.expediente?.[0]?.versions) ? documentInfo.data.expediente[0].versions : []
                    versions = versionsFile
                    versionSelected = file

                    filesDocument = (documentInfo.data.expediente && documentInfo.data.expediente.length > 0) ? documentInfo.data.expediente : []
                } else {
                    decryptUrl = (documentInfo.data.document && documentInfo.data.document.url && documentInfo.data.document.url !== '') ? decryptMessageBoveda(documentInfo.data.document.url) : ''
                    versions = (documentInfo.data.versions && documentInfo.data.versions.length > 0) ? documentInfo.data.versions : []
                    if (versions.length > 0) {
                        versions = versions.map((version) => {
                            version.iconTrashActive = (version.statusType !== process.env.REACT_APP_FILE_STATUS_MAIN_DOC)
                            return version
                        })
                        let versionMain = versions.find((version) => version.statusType === process.env.REACT_APP_FILE_STATUS_MAIN_DOC)
                        versionSelected = (versionMain) ? versionMain : {}
                    } else {
                        versionSelected = {}
                    }

                    filesDocument = (documentInfo.data.versions && documentInfo.data.versions.length > 0) ? documentInfo.data.versions : []

                    const file = (filesDocument && filesDocument.length > 0) ? filesDocument.find(file => file.statusType === process.env.REACT_APP_FILE_STATUS_MAIN_DOC) : null

                    decryptUrl = (file && file.url && file.url !== '') ? decryptMessageBoveda(file.url) : ''
                    fileType = file && file.fileType
                }

                const isDeleted = (
                    documentInfo.data.document.status === this.ENV.REACT_APP_DOCUMENT_STATUS_ELIMINADO ||
                    documentInfo.data.document.status === this.ENV.REACT_APP_DOCUMENT_STATUS_ELIMINADO_PERMANENTEMENTE
                )

                const showPanelActions = this.state.fromDelete ? true : !isDeleted
                const showVersionsBtns = !isDeleted
                const showExpediente = (
                    documentInfo.data.document?.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE
                )

                const filesExpediente = documentInfo.data.expediente || []
                let showVersions = documentInfo.data.versions?.length > 0

                const fileExpSelected = (
                    documentInfo.data.expediente?.length
                        ? documentInfo.data.expediente[0]
                        : {}
                )

                if (documentInfo.data.document.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE && documentInfo.data.expediente && documentInfo.data.expediente.length > 0 && documentInfo.data.expediente[0].versions && documentInfo.data.expediente[0].versions.length > 0) {
                    showVersions = true
                }

                //Verify if is Exp to show btn to upload a new file
                let showBtnAddDocumentToExp = (documentInfo.data.document?.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) ? true : false

                //Verify if document has entities
                let entitiesBD = (documentInfo.data.document && documentInfo.data.document.entities) ? documentInfo.data.document.entities : []
                if (entitiesBD && entitiesBD[0] && Object.keys(entitiesBD).length === 1) {
                    if (Object.keys(entitiesBD[0]).length > 0) entitiesBD = entitiesBD[0]
                }
                let entities = parseEntities(entitiesBD, this.props.t)
                entities = entities.sort((a, b) => a.type.toLowerCase().localeCompare(b.type.toLowerCase()))
                const entitiesStatus = (documentInfo.data.document && documentInfo.data.document.entitiesStatus) ? documentInfo.data.document.entitiesStatus : ''
                const showPanelEntities = documentInfo.data.document.infoType !== this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE && fileType === 'pdf'
                let showBtnExtractEntities = entitiesStatus ? false : true
                const preferenceIA = await this.getClientPreferences()
                if (preferenceIA === this.ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ENABLE) showBtnExtractEntities = false

                // Check if document is an expediente
                const isExpediente = (documentInfo.data && documentInfo.data.document && documentInfo.data.document.infoType) === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE

                // Set left panel visibility flags for expedientes
                const showLeftDownload = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.download) ? true : false
                const showShareLeft = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.share) ? true : false
                const showDeleteLeft = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.delete) ? true : false
                let showEditLeft = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.edit) ? true : false
                const showBtnDeleteDocDeExp = (isExpediente && documentInfo.data.permissions && documentInfo.data.permissions.delete) ? true : false

                // Set default permissions
                let permissions = documentInfo.data.permissions || {
                    alerts: true,
                    edit: true,
                    print: true,
                    download: true,
                    send: true,
                    share: true,
                    delete: true,
                    version: true
                }

                // Override permissions for expedientes
                if (isExpediente) {
                    permissions = {
                        ...permissions,
                        alerts: false,
                        send: false,
                        share: false,
                        delete: false,
                        version: false
                    }
                }

                try {
                    const roles = (this.user && this.user.userMetaData && Array.isArray(this.user.userMetaData.userRoles)) ? this.user.userMetaData.userRoles : []
                    const isSuperAdmin = roles.some(r => (r && r.role && (r.role.key === process.env.REACT_APP_ADMIN || r.role.key === 'roleHibouAdministrator')))
                    const isVaultAdmin = roles.some(r => (r && r.role && (r.role.key === process.env.REACT_APP_ADMIN_DIGITAL_VAULT || r.role.key === 'roleHibouDigitalVaultAdministrator')))

                    const canEdit = isSuperAdmin || isVaultAdmin

                    permissions = { ...permissions, edit: !!canEdit }
                    showEditLeft = (!!canEdit) && (!!showEditLeft || !isExpediente)
                } catch (_) { }

                documentInfo.data.document.variables = documentInfo.data.document.variables.map(variable => {
                    if (!variable.value) return variable
                    variable.iconTrashActive = true
                    if (variable.typeData === 'boolean') {
                        variable.convertedValue = variable.value
                    } else {
                        variable.convertedValue = this.formatTextUtil.formatVariableValue(variable.value, variable.formatVariableKey)
                    }
                    return variable
                })

                this.setState({
                    documentData: documentInfo.data.document,
                    signedInGovo,
                    showCircle,
                    formatTransaction,
                    formatPenaltyFee,
                    variables: documentInfo.data.document.variables,
                    url: decryptUrl,
                    permissions,
                    showActions: showPanelActions,
                    showVersions,
                    versions,
                    showVersionsBtns,
                    showExpediente,
                    filesExpediente,
                    fileExpSelected,
                    versionSelected,
                    showBtnAddDocumentToExp,
                    fileType,
                    asn1Decode,
                    entities,
                    entitiesStatus,
                    filesDocument,
                    showPanelEntities,
                    showLeftDownload,
                    showShareLeft,
                    showDeleteLeft,
                    showEditLeft,
                    showBtnDeleteDocDeExp,
                    showBtnExtractEntities
                })

                await Promise.all([
                    this.getTypesDocumentsVariables(),
                    this.getDocumentAlerts(),
                    this.getDocumentTypes()
                ]).catch(error => {
                    console.warn('Error loading additional document data:', error)
                })

                this.toggleLoadingView(false)
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, true, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        } finally {
            this.loadingDocumentData = false
        }
    }

    // Restaurar desde la Papelera
    handleRestoreDocument = async () => {
        try {
            this.toggleLoadingRequesting(true)
            const isDeletingDocument = !!this.props.isDeletingDocument
            let response

            if (!isDeletingDocument) {
                response = await this.digitalVaultDocumentService.updateDocumentStatus(this.id, this.ENV.REACT_APP_DOCUMENT_ACTION_RESTORE, this.token)
            } else {
                response = await this.digitalVaultService.nextDeleteWorkflowStep(this.id, this.token, false)
            }

            if (response && (response.statusCode === 200 || response.statusCode === 201)) {
                this.toggleCompletedRequesting(7000, true, '/', this.props.t("dialogSystemGLPure.restoredDocument.title"), this.props.t("dialogSystemGLPure.restoredDocument.message"))
            } else {
                throw new Error(response?.message || 'Error al restaurar el documento')
            }
        } catch (error) {
            this.toggleErrorRequesting(error.message || 'Error al restaurar el documento', 4000, false, '', 'Error al Restaurar')
        } finally {
            this.toggleLoadingRequesting(false)
        }
    }

    // Eliminar permanentemente desde Papelera
    handleDeletePermanently = async () => {
        try {
            this.toggleLoadingRequesting(true)
            const isDeletingDocument = !!this.props.isDeletingDocument
            let response

            if (!isDeletingDocument) {
                response = await this.digitalVaultService.startDeleteWorkflow(this.id, true, this.token)
            } else {
                response = await this.digitalVaultService.nextDeleteWorkflowStep(this.id, this.token, true)
            }

            if (response && (response.statusCode === 200 || response.statusCode === 201)) {
                this.toggleCompletedRequesting(7000, true, '/', this.props.t("dialogSystemGLPure.documentDeleted.title"), this.props.t("dialogSystemGLPure.documentDeleted.message"))
            } else {
                throw new Error(response?.message || 'Error al eliminar el documento')
            }
        } catch (error) {
            this.toggleErrorRequesting(error.message || 'Error al eliminar el documento', 4000, false, '', 'Error al Eliminar')
        } finally {
            this.toggleLoadingRequesting(false)
        }
    }


    getBinnacle = async () => {
        if (this.loadingBinnacle) {
            console.warn('getBinnacle already in progress, skipping duplicate call')
            return
        }
        this.loadingBinnacle = true
        let messageError = 'Ocurrió un error al consultar la infomación de la bitácora del documento'
        let clientId = this.user.userMetaData.userA3Cloud.clientId

        try {
            let binnacleBD = await this.documentLogsService.getDocumentLogs(clientId, this.timezone, this.token, this.id)
            if (binnacleBD && binnacleBD.data && Number(binnacleBD.statusCode) === 200) {
                let binnacle = binnacleBD.data.documentLogs.map((register) => {
                    let binnacleInfo = {}
                    binnacleInfo.id = register.id
                    binnacleInfo.date = register.newDate
                    binnacleInfo.sending = register.sending
                    binnacleInfo.sharing = register.sharing
                    binnacleInfo.categoryId = register.categoryId
                    binnacleInfo.subcategoryId = register.subcategoryId
                    binnacleInfo.clientId = register.clientId
                    binnacleInfo.name = this.props.t(`digitalVaultStatisticalReportView.key.${register.documentAction.name}`)
                    binnacleInfo.documentActionId = register.documentAction.id
                    binnacleInfo.nameUser = register.user.email
                    return binnacleInfo
                })
                binnacleBD.data.documentActions = binnacleBD.data.documentActions.map(item => {
                    item.name = this.props.t(`digitalVaultStatisticalReportView.key.${item.name}`)
                    return item
                })
                const actionOptions = [{ id: 0, name: this.props.t('all') }, ...binnacleBD.data.documentActions]
                this.setState({
                    binnacle,
                    actionOptions
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        } finally {
            this.loadingBinnacle = false
        }
    }

    getUsersCollabs = async () => {
        if (this.loadingUsersCollabs) {
            console.warn('getUsersCollabs already in progress, skipping duplicate call')
            return
        }
        this.loadingUsersCollabs = true
        let messageError = 'Ocurrió un error al consultar los usuarios invitados'
        try {
            let usersCollabotartorsList = await this.userService.getUsersToShareDocuments(this.token)
            if (usersCollabotartorsList.statusCode === 200 && usersCollabotartorsList.data) {
                this.setState({
                    userCollaborators: usersCollabotartorsList.data,
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        } finally {
            this.loadingUsersCollabs = false
        }
    }

    getMonetaryUnits = async () => {
        if (this.loadingMonetaryUnits) {
            console.warn('getMonetaryUnits already in progress, skipping duplicate call')
            return
        }
        this.loadingMonetaryUnits = true
        let messageError = 'Ocurrio un error para consultar las unidades monetarias'
        try {
            let monetaryUnits = await this.questionnaireService.getAllCurrencyUnits(this.token)
            if (monetaryUnits.data.statusCode === 200 && monetaryUnits.data.data) {
                this.setState({
                    monetaryUnits: monetaryUnits.data.data,
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (e) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        } finally {
            this.loadingMonetaryUnits = false
        }
    }

    // Nuevo: flujo de eliminar/restaurar desde Inbox
    handleStartDeleteWorkflow = async (deleteDocument) => {
        const defaultMsg = 'Ocurrió un error al procesar la acción'
        try {
            this.toggleLoadingRequesting(true)
            const res = await this.digitalVaultService.startDeleteWorkflow(this.id, deleteDocument, this.token)
            if (res && (res.statusCode === 200 || res.statusCode === 201)) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
            } else {
                throw new Error(res?.message || defaultMsg)
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(e.message || defaultMsg, 4000, false)
        }
    }

    getDocumentAlerts = async () => {
        const documentId = this.state.documentData?.id || this.id
        if (!documentId) {
            console.warn('No document ID available for getDocumentAlerts')
            return
        }
        let messageError = 'Ocurrió un error al consultar las alertas del documento'
        try {
            let documentAlerts = await this.alertService.getAllAlertConfigs(this.token, documentId)
            if (documentAlerts.statusCode === 200 && documentAlerts.data) {
                documentAlerts.data.alerts.forEach(alert => {
                    alert.alertDocumentVariables.forEach(alertVariable => {
                        alertVariable.name = alertVariable?.documentVariable?.variable?.variableName

                    })
                    return alert
                })
                this.setState({
                    documentAlerts: documentAlerts.data.alerts
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (e) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    getTypesDocumentsVariables = async () => {
        const documentId = this.state.documentData?.id || this.id
        if (!documentId) {
            console.warn('No document ID available for getTypesDocumentsVariables')
            return
        }
        let messageError = this.props.t('digitalVaultDocumentView.getDocumentTypes.error')
        try {
            let typesDocuments = await DocumentsType.getTypesByDocumentId(documentId, this.token)
            if (typesDocuments.statusCode === 200 && typesDocuments.data) {
                let copyTypes = [{ id: 0, name: "Selecciona un dato" }, ...typesDocuments.data.variables]
                this.setState({
                    typesDocuments: copyTypes,
                    documentData: {
                        ...this.state.documentData,
                        typeDocumentId: this.state.documentData?.typeDocumentId || (Number.isFinite(Number(typesDocuments.data.id)) ? Number(typesDocuments.data.id) : typesDocuments.data.id)
                    }
                })
            } else if (typesDocuments.statusCode === 200 && !typesDocuments.data) {
                this.toggleLoadingView(false)
                this.toggleWarning(this.props.t('digitalVaultDocumentView.getDocumentTypes.warning'), 4000, this.props.t('digitalVaultDocumentView.getDocumentTypes.warning.title'))
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (e) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    /**
     * @type {CreateAlert}
     * @memberof DigitalVaultDocumentAction
     */
    createAlert = async (data) => {
        let result = false
        try {
            this.toggleLoadingRequesting(true)
            const alert = await this.alertService.createAlert(this.token, data)

            if (alert.statusCode === 200) {
                await this.getDocumentAlerts()
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
                result = true
                return result
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting('Ocurrió un error al crear la alerta', 4000, false, '/')
                result = false
                return result
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting('Ocurrió un error al crear la alerta', 4000, false, '/')
            result = false
            return result
        }
    }

    deleteAlert = async (alertId) => {
        let wasSuccessful = false
        try {
            this.toggleLoadingRequesting(true)
            const result = await this.alertService.deleteAlert(this.token, alertId)

            if (result.statusCode === 200) {
                await this.getDocumentAlerts()
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
                wasSuccessful = true
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('documentPanelBarAlerts.alerts.deleteError'), 4000, false, '/')
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(this.props.t('documentPanelBarAlerts.alerts.deleteError'), 4000, false, '/')
        } finally {
            return wasSuccessful
        }
    }

    getFormatVariables = async () => {
        if (this.loadingFormatVariables) {
            console.warn('getFormatVariables already in progress, skipping duplicate call')
            return
        }
        this.loadingFormatVariables = true
        try {
            let formatVariables = await this.questionnaireService.getAllFormatsForVariables(this.token)
            if (formatVariables.length) {
                formatVariables = formatVariables
                    .filter(f => f.groupName !== 'selection')
                    .map(f => ({
                        ...f,
                        format: this.props.t(`formatVariable.key.${f.key}`)
                    }))
                this.setState({
                    formatVariables
                })
            }
        } catch (e) {
            console.error('Error fetching format variables:', e)
        } finally {
            this.loadingFormatVariables = false
        }
    }

    /**
     * @param {*} data
     * @memberof DigitalVaultDocumentAction
     */
    createOrUpdateVariable = async (data) => {
        this.toggleLoadingRequesting(true)
        let messageError = this.props.t('digitalVaultDocumentView.createVariable.error')
        try {
            const payload = {
                variableId: (data?.variableId != null ? data.variableId : (data?.id != null ? data.id : null)),
                typeDocumentId: data.typeDocumentId,
                variableName: data.variableName || data.name,
                typeData: data.typeData || data.type,
                formatVariableKey: data.formatVariableKey || data.format,
                dataProfile: data.dataProfile || data.profile,
                mandatory: !!(data.mandatory),
                documentId: data.documentId || this.state.documentData.id,
                valueVariable: data.valueVariable ?? data.value ?? null,
                entityType: data.entityType ?? null,
                token: this.token
            }

            let resolvedTypeDocumentId = Number.isFinite(Number(payload.typeDocumentId)) && Number(payload.typeDocumentId) > 0
                ? Number(payload.typeDocumentId)
                : (Number.isFinite(Number(this.state.documentData?.typeDocumentId)) && Number(this.state.documentData?.typeDocumentId) > 0
                    ? Number(this.state.documentData?.typeDocumentId)
                    : null)

            if (!resolvedTypeDocumentId) {
                try {
                    const typesResp = await DocumentsType.getTypesByDocumentId(this.state.documentData.id, this.token)
                    const maybeId = Number(typesResp?.data?.id)
                    if (Number.isFinite(maybeId) && maybeId > 0) {
                        resolvedTypeDocumentId = maybeId
                        this.setState(prev => ({
                            documentData: { ...prev.documentData, typeDocumentId: maybeId }
                        }))
                    }
                } catch (_) { /* noop */ }
            }

            if (!resolvedTypeDocumentId) {
                this.toggleErrorRequesting('No se pudo determinar el tipo de documento (typeDocumentId).', 4000, false, '/')
                return
            }

            const resolvedDocumentId = payload.documentId ?? this.state.documentData?.id

            let response = await this.documentTypesService.createOrUpdateVariable({
                ...payload,
                typeDocumentId: resolvedTypeDocumentId,
                documentId: resolvedDocumentId
            })

            if (response.statusCode === 200) {
                try {
                    const documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    if (documentInfo && documentInfo.data && Number(documentInfo.statusCode) === 200) {
                        let docVars = documentInfo.data.document?.variables || []
                        docVars = docVars.map(variable => {
                            if (variable.value) variable.iconTrashActive = true
                            if (variable.typeData === 'boolean') {
                                variable.convertedValue = variable.value
                            } else {
                                variable.convertedValue = this.formatTextUtil.formatVariableValue(variable.value, variable.formatVariableKey)
                            }
                            return variable
                        })
                        this.setState({
                            documentData: {
                                ...documentInfo.data.document,
                                typeDocumentId: resolvedTypeDocumentId || this.state.documentData?.typeDocumentId || documentInfo.data.document?.typeDocumentId
                            },
                            variables: docVars,
                            variablesGrid: response.data || []
                        })
                        await this.refreshDocumentVariables()
                        this.toggleLoadingRequesting(false)
                        this.toggleCompletedRequesting(4000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'))
                        return true
                    } else {
                        const variables = response.data || []
                        this.setState({ variables, variablesGrid: variables })
                        this.toggleLoadingRequesting(false)
                        this.toggleCompletedRequesting(4000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'))
                        return true
                    }
                } catch (e) {
                    const variables = response.data || []
                    this.setState({ variables, variablesGrid: variables })
                    this.toggleLoadingRequesting(false)
                    this.toggleCompletedRequesting(4000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'))
                    return true
                }
            } else {
                switch (response.statusCode) {
                    case 409:
                        messageError = this.props.t('digitalVaultDocumentView.createVariable.error.nameAlreadyExists')
                        break
                    default:
                        messageError = this.props.t('digitalVaultDocumentView.createVariable.error')
                        break
                }
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
                return false
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return false
        }
    }

    /**
     * @param {import('../../../types/DocumentVariable.types').DocumentVariablePOSTData} data
     * @returns {Promise<boolean>}
     */
    createVariable = async (data) => {
        return this.createOrUpdateVariable(data)
    }

    /**
     * @param {import('../../../types/DocumentVariable.types').DocumentVariablePOSTData} data
     * @memberof DigitalVaultDocumentAction
     */
    updateVariable = async (data) => {
        let messageError = 'Ocurrió un error al actualizar la variable'
        try {
            this.toggleLoadingRequesting(true)
            let resolvedTypeDocumentId = Number.isFinite(Number(this.state.documentData?.typeDocumentId)) && Number(this.state.documentData?.typeDocumentId) > 0
                ? Number(this.state.documentData?.typeDocumentId)
                : null
            if (!resolvedTypeDocumentId) {
                try {
                    const typesResp = await DocumentsType.getTypesByDocumentId(this.state.documentData.id, this.token)
                    const maybeId = Number(typesResp?.data?.id)
                    if (Number.isFinite(maybeId) && maybeId > 0) {
                        resolvedTypeDocumentId = maybeId
                        this.setState(prev => ({ documentData: { ...prev.documentData, typeDocumentId: maybeId } }))
                    }
                } catch (_) { /* noop */ }
            }

            if (!resolvedTypeDocumentId) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting('No se pudo determinar el tipo de documento (typeDocumentId).', 4000, false, '/')
                return
            }
            const wantsValueUpdate = Object.prototype.hasOwnProperty.call(data || {}, 'valueVariable')

            const payload = {
                variableId: (data?.variableId != null ? data.variableId : data?.id),
                typeDocumentId: resolvedTypeDocumentId,
                variableName: (typeof data?.variableName === 'string' ? data.variableName : data?.name),
                typeData: (typeof data?.typeData === 'string' ? data.typeData : data?.type),
                // If empty string is received, treat as null to avoid unintended format changes
                formatVariableKey: (data?.formatVariableKey === '' ? null : (typeof data?.formatVariableKey === 'string' ? data.formatVariableKey : data?.format ?? null)),
                dataProfile: (data?.dataProfile != null ? data.dataProfile : data?.profile ?? null),
                mandatory: !!data?.mandatory,
                documentId: wantsValueUpdate ? (data?.documentId != null ? data.documentId : this.state.documentData?.id ?? null) : null,
                valueVariable: (Object.prototype.hasOwnProperty.call(data || {}, 'valueVariable') ? data.valueVariable : undefined),
                entityType: (data?.entityType != null ? data.entityType : null),
                token: this.token
            }

            if (!payload.variableId) {
                const byName = (this.state.variables || []).find(v => v && v.name === payload.variableName)
                if (byName && byName.id) payload.variableId = byName.id
            }

            if (!payload.variableId) {
                try {
                    const docInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    if (docInfo && docInfo.data && Number(docInfo.statusCode) === 200) {
                        const vars = docInfo.data.document?.variables || []
                        const byName = vars.find(v => v && v.name === payload.variableName)
                        if (byName && byName.id) {
                            payload.variableId = byName.id
                            this.setState({ variables: vars })
                        }
                    }
                } catch (_) { /* noop */ }
            }

            // Prevent accidental create when updating without variableId
            if (!payload.variableId) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting('No se pudo identificar el dato personalizado a actualizar. Vuelve a seleccionar el elemento e inténtalo de nuevo.', 4000, false, '/')
                return
            }

            let response = await this.documentTypesService.createOrUpdateVariable(payload)
            if (response.statusCode === 200) {
                try {
                    const documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    if (documentInfo && documentInfo.data && Number(documentInfo.statusCode) === 200) {
                        let docVars = documentInfo.data.document?.variables || []
                        docVars = docVars.map(variable => {
                            if (variable.value) variable.iconTrashActive = true
                            variable.convertedValue = FormatTextUtil.formatVariableValue(variable.value, variable.formatVariableKey)
                            return variable
                        })
                        this.setState({
                            documentData: {
                                ...documentInfo.data.document,
                                typeDocumentId: resolvedTypeDocumentId || this.state.documentData?.typeDocumentId || documentInfo.data.document?.typeDocumentId
                            },
                            variables: docVars,
                            variablesGrid: response.data || []
                        })
                        await this.refreshDocumentVariables()
                        this.toggleLoadingRequesting(false)
                        this.toggleCompletedRequesting(3000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'), this.props.t('digitalVaultDocumentAction.variable.update.success'))
                    }
                } catch (e) {
                    this.toggleLoadingRequesting(false)
                }
            } else {
                this.toggleLoadingRequesting(false)
                if (Number(response.statusCode) === 409) {
                    this.toggleErrorRequesting('Ya existe un dato personalizado con ese nombre en este tipo de documento. Edita solo el valor, no el nombre.', 4500, false, '/')
                } else if (Number(response.statusCode) === 405) {
                    this.toggleErrorRequesting('El dato personalizado no fue encontrado.', 4000, false, '/')
                } else {
                    this.toggleErrorRequesting(messageError, 4000, false, '/')
                }
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    deleteVariable = async (variable) => {
        const messageError = 'Ocurrió un error al eliminar la variable'
        try {
            const variableId = (variable && typeof variable === 'object') ? Number(variable.id ?? variable.variableId) : Number(variable)
            if (!variableId) {
                this.toggleErrorRequesting('No se pudo determinar el id de la variable a eliminar.', 4000, false, '/')
                return false
            }
            const response = await this.documentTypesService.deleteVariable({ variableId, token: this.token })
            if (response.statusCode === 200) {
                try {
                    const documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    const docVars = documentInfo?.data?.document?.variables || []
                    docVars.forEach(variable => {
                        if (variable.value) variable.iconTrashActive = true
                    })

                    this.setState(prev => ({
                        documentData: { ...documentInfo.data.document, typeDocumentId: prev.documentData?.typeDocumentId || documentInfo.data.document?.typeDocumentId },
                        variables: docVars
                    }))
                    await this.refreshDocumentVariables()
                } catch (_) {
                    this.setState({ variables: response.data || [] })
                }
                this.toggleCompletedRequesting(3000, false, '/')
                return true
            } else if (Number(response.statusCode) === 410) {
                this.toggleErrorRequesting('El dato personalizado tiene valores asignados y no puede eliminarse.', 4000, false, '/')
                return false
            } else {
                this.toggleErrorRequesting(messageError, 4000, false, '/')
                return false
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return false
        }
    }

    /**
     * Borra solo el valor de una variable para el documento actual (no elimina la definición)
     * @param {import('../../../types/DocumentVariable.types').DocumentVariableGETResponse | { id: number } | number} variable
     * @returns {Promise<boolean>}
     */
    clearVariableValue = async (variable) => {
        const messageError = this.props.t('digitalVaultDocumentAction.variable.delete.error')
        const documentId = this.state?.documentData?.id
        try {
            this.toggleLoadingRequesting(true)
            const variableId = (variable && typeof variable === 'object') ? Number(variable.id ?? variable.variableId) : Number(variable)
            if (!variableId || !documentId) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.variable.delete.error.id'), 4000, false, '/')
                return false
            }

            const response = await this.documentTypesService.deleteVariableValue({ variableId, documentId, token: this.token })
            if (Number(response?.statusCode) === 200) {
                try {
                    const documentInfo = await this.categoryService.getDocumentVaultData(this.id, this.timezone, this.token)
                    const docVars = documentInfo?.data?.document?.variables || []
                    docVars.forEach(variable => {
                        if (!variable.value) return variable
                        variable.iconTrashActive = true
                        if (variable.typeData === 'boolean') {
                            variable.convertedValue = variable.value
                        } else {
                            variable.convertedValue = this.formatTextUtil.formatVariableValue(variable.value, variable.formatVariableKey)
                        }
                        return variable
                    })
                    this.setState(prev => ({
                        documentData: { ...documentInfo.data.document, typeDocumentId: prev.documentData?.typeDocumentId || documentInfo.data.document?.typeDocumentId },
                        variables: docVars
                    }))
                } catch (_) {
                    // Best-effort: fallback to mapping current variables with cleared value
                    const current = (this.state.variables || []).map(v => (v.id === variableId ? { ...v, value: null } : v))
                    this.setState({ variables: current })
                }
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/', this.props.t('digitalVaultDocumentAction.variable.title.success'), this.props.t('digitalVaultDocumentAction.variable.delete.success'))
                return true
            } else if (Number(response?.statusCode) === 405) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.variable.delete.error.notValue'), 4000, false, '/')
                return false
            } else if (Number(response?.statusCode) === 404) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.variable.delete.error.userNotFound'), 4000, false, '/')
                return false
            } else if (Number(response?.statusCode) === 420) {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.variable.delete.error.invalidData'), 4000, false, '/')
                return false
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
                return false
            }
        } catch (e) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            return false
        }
    }

    handleAlerts = async (e, documentId) => {
        let newParams = new URLSearchParams()
        newParams.append('doc', documentId)
        this.props.history.push({ pathname: `/digital-vault/alerts`, search: newParams.toString() })
    }

    handleEditDoc = async () => {
        this.setState({
            showPrincipalView: false,
            showEditView: true
        })

        this.props.history.push({
            pathname: `/follow-up-registration-document/${this.state.documentData.id}`, state: {
                from: this.props.location.pathname,
                documentId: this.props.id,
                ...this.props.stateToMaintain
            }
        })
    }

    handlePrintDoc = async (e, documento, isDocument) => {
        let messageError = this.props.t('digitalVaultDocumentAction.errors.print')

        try {
            this.toggleLoadingRequesting(true)

            // Get the document URL
            let url = documento?.url || this.state.url

            // If it's an expediente and there's a selected file, use its URL
            if (isDocument && this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
                const fileSelected = this.state.filesExpediente.find(file => file.selected)
                if (fileSelected?.url) {
                    url = fileSelected.url
                }
            }

            if (!url) throw new Error(this.props.t('digitalVaultDocumentAction.errors.print.no.url'))

            // Create the log
            let documentId = this.id
            let documentActionId = 6
            let sending = null
            let sharing = null
            await this.digitalVaultService.createDocumentLog(documentId, documentActionId, sending, sharing, this.token)

            // Decrypt the AWS URL
            const urlDecrypted = decryptMessageBoveda(url)

            // Create a temporary link and open in new window for printing
            const printWindow = window.open(urlDecrypted, '_blank')

            if (printWindow) {
                // Wait for it to load and then print
                printWindow.onload = () => {
                    printWindow.print()
                }
            } else {
                throw new Error(this.props.t('digitalVaultDocumentAction.errors.print.blocked.window'))
            }

            this.toggleLoadingRequesting(false)

        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
            console.error('Error in handlePrintDoc:', error)
        }
    }

    handleDownloadDoc = async (isDocument) => {
        let messageError = this.props.t('digitalVaultDocumentView.download.error.message')
        let documentId = this.id
        if (isDocument && this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
            const fileSelected = this.state.filesExpediente.find(file => { return file.selected })
            if (fileSelected && fileSelected.documentId) documentId = fileSelected.documentId
        }
        this.toggleLoadingRequesting(true)
        try {
            const response = await this.digitalVaultDocumentService.downloadFile({ documentId: documentId, token: this.token })
            if (response.statusCode === 200 && response.data) {
                if (!response.data.sendEmail && response.data.url) {
                    this.toggleLoadingRequesting(false)

                    const link = document.createElement('a')
                    link.href = response.data.url
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)

                    this.toggleCompletedRequesting(4000, false, '/', 'digitalVaultDocumentView.browserDownload.completed.title', 'digitalVaultDocumentView.browserDownload.completed.message')
                } else {
                    this.toggleLoadingRequesting(false)
                    this.toggleCompletedRequesting(4000, false, '/', 'digitalVaultDocumentView.emailDownload.completed.title', 'digitalVaultDocumentView.emailDownload.completed.message')
                }
            }

        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/', 'digitalVaultDocumentView.download.error.title')
        }
    }


    handleSendEmailDoc = async (emails, documentId, comments, setEmail, setMessageEmail, fileIdExp) => {
        let messageError = 'Ocurrió un error al enviar el correo'
        try {
            let sendEmail = await this.categoryService.sendEmailDocumentVault(emails, documentId, comments, fileIdExp, this.token)
            if (sendEmail && Number(sendEmail.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                setEmail('')
                setMessageEmail('')
                this.toggleCompletedRequesting(3000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleShareDoc = async (payload, setUsersSend, setUsersSendGrid, setUsersChip, setShowDialogShare, setMessageShare) => {
        setShowDialogShare(false)
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al compartir el documento con los usuarios'

        try {
            const shareDocument = await this.categoryService.shareDocumentUsers(payload, this.token)
            if (shareDocument && Number(shareDocument.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                setUsersSend('')
                setUsersSendGrid([])
                setUsersChip([])
                setMessageShare('')
                this.toggleCompletedRequesting(3000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
            setShowDialogShare(true)
        }
    }

    handleDeleteDoc = async (documentToDelete) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un erro al eliminar el documento'

        try {
            let documentId = (documentToDelete && documentToDelete.id) ? documentToDelete.id : this.id
            let status = 'Papelera'
            let documentDeleted = await this.digitalVaultDocumentService.updateDocumentStatus(documentId, status, this.token)
            if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
                this.cache.deleteUrlFromCache('/documents-for-subcategory')
                if (documentToDelete && documentToDelete.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_DOC_DE_EXP) {
                    await this.getDocumentData()
                    return
                }

                if (this.props.goBack) this.props.goBack()

            } else if (documentDeleted && documentDeleted.data && (Number(documentDeleted.statusCode) === 5 || Number(documentDeleted.statusCode) === 8)) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 6) {
                messageError = 'No se actualizó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 7) {
                messageError = 'No se eliminó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (documentDeleted && documentDeleted.data && Number(documentDeleted.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleVersionDoc = async (e, setShowDialogVersion, documentId, fileIdExp) => {
        let messageError = 'Ocurrió un error al versionar el documento'
        setShowDialogVersion(false)
        this.toggleLoadingRequesting(true)
        let file = this.state.selectedFile
        let documentoToVersion = new FormData()
        documentoToVersion.append('documento', file)
        documentoToVersion.append('documentId', documentId)
        if (this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
            documentoToVersion.append('fileIdExp', fileIdExp)
        }

        try {
            let versionDocumento = await this.digitalVaultDocumentService.versionDocument(documentoToVersion, this.token)
            if (versionDocumento && versionDocumento.data && Number(versionDocumento.statusCode) === 200) {
                // this.handleFileWasUpload(file)
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.handleDeleteFile()
                this.getDocumentData()
            } else if (Number(versionDocumento.statusCode) === 4) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(versionDocumento.statusCode) === 5) {
                messageError = 'No se pudo guardar el documento en AWS'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(versionDocumento.statusCode) === 6) {
                messageError = 'Ocurrió un error al crear el registro en la base de datos'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(versionDocumento.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleFile = async (e) => {
        this.setState({
            selectedFile: e.target.files[0],
            selectedFileName: e.target.files[0].name,
            errorFile: false,
            colorBorderContainer: 'green',
        })

        // Upload the base64 in the state
        let fileBase64 = await this.pdfToBase64(e.target.files[0])
        let pdfBase64 = fileBase64.split(',')[1]
        this.setState({ selectedFileBase64: pdfBase64 })
    }

    pdfToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (error) => reject(error)
        })

    handleDeleteFile = (e) => {
        this.setState({
            selectedFile: null,
            errorFile: false,
            selectedFileBase64: '',
            colorBorderContainer: 'gray',
        })
        return true
    }

    handleFileWasUpload = async (file) => {
        //Cambiar el documento que se mostraba de AWS por el que se acaba de seleccionar
        let fileBase64 = await this.pdfToBase64(file)
        let pdfBase64 = fileBase64.split(',')[1]
        this.setState({
            fileWasUpload64: pdfBase64
        })
    }

    handleShowPrincipalView = (e) => {
        this.setState({
            showEditView: false,
            showPrincipalView: true
        })
    }

    handleSelectVersion = (versionDoc) => {
        let url = (versionDoc && versionDoc.url && versionDoc.url !== '') ? decryptMessageBoveda(versionDoc.url) : ''
        if (url) {
            let copyVersions = this.state.versions
            let newVersions = copyVersions.map((version) => {
                if (versionDoc.id === version.id) {
                    version.selected = true
                } else {
                    version.selected = false
                }
                return version
            })
            this.setState({
                url,
                versions: newVersions,
                versionSelected: versionDoc
            })
        }
    }

    handleDeleteFileVersion = async (fileId) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un erro al eliminar el documento'

        try {
            let documentId = this.id
            let status = 'Eliminar'
            let versionDeleted = await this.digitalVaultDocumentService.updateDocumentStatus(documentId, status, this.token, fileId)
            if (versionDeleted && versionDeleted.data && Number(versionDeleted.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.getDocumentData()
            } else if (versionDeleted && (Number(versionDeleted.statusCode) === 5 || Number(versionDeleted.statusCode) === 8)) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 6) {
                messageError = 'No se actualizó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 7) {
                messageError = 'No se eliminó el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 9) {
                messageError = 'No se eliminó el file en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (versionDeleted && Number(versionDeleted.statusCode) === 10) {
                messageError = 'No se puede eliminar el archivo principal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleMakeVersionMainDoc = async (version) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al hacer principal a la versión'
        let documentId = this.id
        let fileId = version.id
        let mainDoc = null
        if (this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) {
            mainDoc = version.mainDoc
        }
        try {
            let mainDocVersion = await this.digitalVaultDocumentService.makeVersionMainDoc(documentId, fileId, mainDoc, this.token)
            if (mainDocVersion && mainDocVersion.data && Number(mainDocVersion.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.getDocumentData()
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 4) {
                messageError = 'No se encontró el documento en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 5) {
                messageError = 'No se pudieron acutalizar las versiones a verDoc'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 6) {
                messageError = 'No se pudo actualizar la versión como principal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (mainDocVersion && Number(mainDocVersion.statusCode) === 403) {
                messageError = 'No se encontró el usuario en govo.legal'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleWatchExp = (fileExp) => {
        if (!fileExp) return
        const newDocumentId = (fileExp.document && fileExp.document.id) ? fileExp.document.id : null
        this.openNewDocumentInView(null, newDocumentId)
    }


    handleSelectFileExp = (fileExp) => {
        if (!fileExp) return

        switch (fileExp.fileType) {
            case null:
                this.setState({ fileType: 'pdf' })
                break
            default:
                this.setState({ fileType: fileExp.fileType })
                break
        }

        let decryptUrl = (fileExp && fileExp.url && fileExp.url !== '') ? decryptMessageBoveda(fileExp.url) : ''

        const isAsn1OctetFile = (expediente, ENV) => {
            return (
                expediente.fileType === ENV.REACT_APP_OCTET_STREAM_TYPE &&
                expediente.extension === ENV.REACT_APP_ASN1_EXTENSION
            )
        }

        const asn1Decode = isAsn1OctetFile(fileExp, this.ENV)
            ? [fileExp.asn1Parse]
            : []

        let copyFilesExp = this.state.filesExpediente
        let newFilesExp = copyFilesExp.map((file) => {
            if (file.id === fileExp.id) {
                file.selected = true
            } else {
                file.selected = false
            }
            return file
        })

        let showVersions = (fileExp.versions.length > 0) ? true : false

        this.setState({
            url: decryptUrl,
            asn1Decode,
            showVersions,
            versions: fileExp.versions,
            filesExpediente: newFilesExp,
            fileExpSelected: fileExp,
            versionSelected: fileExp
        })

    }

    addNewFileToExp = async (e) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al guardar el documento'
        if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
            messageError = 'Selecciona un archivo'
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
            return
        }

        let file = e.target.files[0]
        let documentId = this.state.documentData.id
        let documentData = new FormData()
        documentData.append('newDocument', file)
        documentData.append('documentId', documentId)

        try {
            let addFile = await this.digitalVaultDocumentService.addFileToExpediente(documentData, this.token)
            if (addFile && addFile.data && Number(addFile.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(5000, false, '/')
                this.getDocumentData()
            } else if (Number(addFile.statusCode) === 403) {
                messageError = 'El usuario no existe en el sistema'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(addFile.statusCode) === -4) {
                messageError = 'El expediente no exxiste en el sistema'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else if (Number(addFile.statusCode) === -5 || Number(addFile.statusCode) === -6) {
                messageError = 'Ocurrió un error al guardar el documento'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }
    }

    handleSignRequest = () => {
        this.props.history.push({
            pathname: `/signature-request-profile/1`,
            params: {
                documentData: this.state.documentData,
            },
        })
    }

    setShowDialogEntities = () => {
        const documents = []
        const typeFile = (this.state.documentData && this.state.documentData.infoType && this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) ? this.ENV.REACT_APP_FILE_STATUS_MAIN_EXP : this.ENV.REACT_APP_FILE_STATUS_MAIN_DOC
        const mainDocs = this.state.filesDocument.filter(doc => doc.statusType === typeFile && doc.fileType === 'pdf')
        mainDocs.forEach((doc) => {
            documents.push({
                id: doc.id,
                name: doc.fileName,
                pages: doc.pages
            })
        })

        if (documents.length === 0) {
            this.toggleErrorRequesting(this.props.t('digitalVaultDocumentAction.errors.no.docs.entities'), 4000, false)
            return
        }

        const docsCreditsOCR = setCreditsToDocuments(documents, this.props.t)
        const documentsToOCR = (docsCreditsOCR && docsCreditsOCR.documentsToOCR) ? docsCreditsOCR.documentsToOCR : []
        const totalCredits = (docsCreditsOCR && docsCreditsOCR.totalCredits) ? docsCreditsOCR.totalCredits : 0

        this.setState({
            showDialogExtractEntities: true,
            documentsToOCR,
            totalCredits
        })
    }

    setCloseDialogEntities = () => {
        this.setState({
            showDialogExtractEntities: false,
            documentsToOCR: [],
            totalCredits: 0
        })
    }

    saveExtractedEntities = async () => {
        let messageError = this.props.t('digitalVaultDocumentAction.errors.save.entities')
        try {
            let documentsSendToOCR = this.state.documentsToOCR.filter(doc => doc.value)
            documentsSendToOCR = documentsSendToOCR.map((doc) => {
                doc.fileId = doc.id
                return doc
            })

            if (documentsSendToOCR.length === 0) {
                messageError = this.props.t('digitalVaultDocumentAction.errors.no.docs.entities')
                this.setCloseDialogEntities()
                this.toggleErrorRequesting(messageError, 4000, false)
                return
            }

            if (this.state.preferenceIA === this.ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_AUTOMATIC || this.state.preferenceIA === this.ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_BOTH) {
                const documents = []
                const typeFile = (this.state.documentData && this.state.documentData.infoType && this.state.documentData.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE) ? this.ENV.REACT_APP_FILE_STATUS_MAIN_EXP : this.ENV.REACT_APP_FILE_STATUS_MAIN_DOC
                const mainDocs = this.state.filesDocument.filter(doc => doc.statusType === typeFile && doc.fileType === 'pdf')
                mainDocs.forEach((doc) => {
                    documents.push({
                        id: doc.id,
                        name: doc.fileName,
                        pages: doc.pages
                    })
                })

                const docsCreditsOCR = setCreditsToDocuments(documents, this.props.t)
                documentsSendToOCR = (docsCreditsOCR && docsCreditsOCR.documentsToOCR) ? docsCreditsOCR.documentsToOCR : []
            }

            this.setCloseDialogEntities()
            this.toggleLoadingRequesting(true)

            const extractEntities = await this.digitalVaultDocumentService.sendEntitiesToExtract(this.id, documentsSendToOCR, this.token)
            if (extractEntities && extractEntities.data && Number(extractEntities.statusCode) === 200) {
                this.setState({
                    entitiesStatus: this.ENV.REACT_APP_EVENT_TRANSACTION_STATUS_OCR_PROCESSING,
                    showBtnExtractEntities: false
                })
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false)
        }

    }

    handleCheckBoxDoc = async (e, dataItem) => {
        let copyDocs = [...this.state.documentsToOCR]
        let valueCheck = e.target.checked

        // Restriction: Do not allow deselecting processId 3 if processId 4 or 6 is selected for the same file.
        if (dataItem.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_OCR_ID) && !valueCheck) {
            const hasProcess4Or6Selected = copyDocs.some(doc =>
                doc.id === dataItem.id &&
                (doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_ENTITIES_EXTRACTION_ID) || doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_EMBEDDINGS_ID)) &&
                doc.value
            )

            // if processId 4 or 6 is selected, prevent deselecting processId 3
            if (hasProcess4Or6Selected) {
                return
            }
        }

        // Toggle the value property of the target document
        copyDocs = copyDocs.map((doc) => {
            if (doc.id === dataItem.id && doc.processId === dataItem.processId) {
                doc.value = valueCheck
            }
            return doc
        })

        // Auto-selection logic: If the current document is processId 4 or 6, manage processId 3 of the same file
        if (dataItem.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_ENTITIES_EXTRACTION_ID) || dataItem.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_EMBEDDINGS_ID)) {
            // Find processId 3 of the same file (same id, different processId)
            const process3SameFile = copyDocs.find(doc => doc.id === dataItem.id && doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_OCR_ID))

            if (process3SameFile) {
                if (valueCheck) {
                    // If processId 4 or 6 is being selected, auto-select processId 3 of the same file
                    process3SameFile.value = true
                } else {
                    // If processId 4 or 6 is being deselected, check if there are other 4 or 6 selected for the same file
                    const hasOtherProcess4Or6Selected = copyDocs.some(doc =>
                        doc.id === dataItem.id &&
                        (doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_ENTITIES_EXTRACTION_ID) || doc.processId === Number(process.env.REACT_APP_EVENT_TRANSACTION_TYPE_EMBEDDINGS_ID)) &&
                        doc.processId !== dataItem.processId &&
                        doc.value
                    )

                    // If no other processId 4 or 6 is selected for this file, deselect processId 3
                    if (!hasOtherProcess4Or6Selected) {
                        process3SameFile.value = false
                    }
                }
            }
        }

        // Recalculate total credits
        let totalCredits = 0
        copyDocs.forEach(doc => {
            if (doc.value) {
                totalCredits += doc.credits || 0
            }
        })

        this.setState({
            documentsToOCR: copyDocs,
            totalCredits
        })
    }

    openNewDocumentInView = (e, newDocumentId) => {
        if (e) e.preventDefault()
        if (!newDocumentId) return
        const messageError = 'Ocurrió un error al consultar el documento'

        this.toggleLoadingView(true)
        this.id = newDocumentId
        try {
            this.getDocumentData()
            this.getBinnacle()
            this.getUsersCollabs()
            this.getMonetaryUnits()
            this.getFormatVariables()
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    refreshDocumentVariables = async () => {
        try {
            await this.getTypesDocumentsVariables()
            await this.getDocumentAlerts()
        } catch (e) {
            console.log(e)
        }
    }

    getDocumentTypes = async () => {
        try {
            const documentTypes = await this.documentTypesService.getAllTypeDocuments(this.token)
            if (!documentTypes || !documentTypes.data) throw new Error('No document types found')
            const filteredDocumentTypes = documentTypes.data.filter(docType => docType.infoType === this.state.documentData.infoType)
            this.setState({ documentTypes: filteredDocumentTypes || [] })
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting('', 4000, false)
        }
    }

    // Get client preferences
    getClientPreferences = async () => {
        try {
            const clientPreferences = await this.clientPreferencesService.getClientPreferences(this.token, this.timezone)
            let preferenceIAFound = clientPreferences.data.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_DOCUMENT_TO_OCR)
            const preferenceIA = (preferenceIAFound && preferenceIAFound.stringValue) ? preferenceIAFound.stringValue : process.env.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ON_DEMAND
            this.setState({
                preferenceIA
            })
            return preferenceIA
        } catch (error) {
            return process.env.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ON_DEMAND
        }

    }

    render() {
        return (
            <DigitalVaultDocumentView
                {...this.props}
                {...this.state}
                toggleWarning={this.toggleWarning}
                createOrUpdateVariable={this.createOrUpdateVariable}
                createAlert={this.createAlert}
                deleteAlert={this.deleteAlert}
                updateVariable={this.updateVariable}
                createVariable={this.createVariable}
                clearVariableValue={this.clearVariableValue}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleLoadingView={this.toggleLoadingView}
                handleAlerts={this.handleAlerts}
                handleEditDoc={this.handleEditDoc}
                handlePrintDoc={this.handlePrintDoc}
                handleDownloadDoc={this.handleDownloadDoc}
                handleSendEmailDoc={this.handleSendEmailDoc}
                handleShareDoc={this.handleShareDoc}
                handleDeleteDoc={this.handleDeleteDoc}
                handleVersionDoc={this.handleVersionDoc}
                handleSignRequest={this.handleSignRequest}
                handleFile={this.handleFile}
                handleDeleteFile={this.handleDeleteFile}
                handleShowPrincipalView={this.handleShowPrincipalView}
                handleSelectVersion={this.handleSelectVersion}
                handleDeleteFileVersion={this.handleDeleteFileVersion}
                handleMakeVersionMainDoc={this.handleMakeVersionMainDoc}
                handleWatchExp={this.handleWatchExp}
                handleSelectFileExp={this.handleSelectFileExp}
                addNewFileToExp={this.addNewFileToExp}
                setShowDialogEntities={this.setShowDialogEntities}
                setCloseDialogEntities={this.setCloseDialogEntities}
                saveExtractedEntities={this.saveExtractedEntities}
                handleCheckBoxDoc={this.handleCheckBoxDoc}
                handleStartDeleteWorkflow={this.handleStartDeleteWorkflow}
                handleDeletePermanently={this.handleDeletePermanently}
                handleRestoreDocument={this.handleRestoreDocument}
                deleteVariable={this.deleteVariable}
                openNewDocumentInView={this.openNewDocumentInView}
            />
        )
    }
}

export default withRouter(withTranslation()(DigitalVaultDocumentAction))